import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  ColumnValues,
  ColumnValueFirst,
  ColumnValuesBegEnd,
  ColumnWrapDiv
} from "./styles";
import formatter from "../../../../utils/formatter";
import { milliToDate } from "../../../../utils/commonUtil";
import PrintTable from "../../../../CommonComponents/PrintTable/PrintTable";

export const renderData = (data, property) => {
  if (property === "fromTo") {
    return (
      <div>
        <ColumnValueFirst paddingBottom="20px">
          <ColumnValues>From </ColumnValues>
        </ColumnValueFirst>
        <ColumnValues>To</ColumnValues>
      </div>
    );
  } else {
    return (
      <div>
        <ColumnValueFirst paddingBottom="20px">
          <ColumnValues>
            {(() => {
              let htmlArray = [];
              switch (property) {
                case "amount":
                case "nav":
                  if (data.from[property]) {
                    htmlArray.push(
                      formatter({
                        value: data.from[property],
                        fieldSuffix: "Dollars"
                      })
                    );
                  } else if (data.from[property] === 0) {
                    htmlArray.push("$0.00");
                  } else {
                    htmlArray.push("-");
                  }
                  break;
                case "date":
                  if (data.from[property]) {
                    htmlArray.push(milliToDate(data.from[property]));
                  } else {
                    htmlArray.push("-");
                  }
                  break;
                case "percentage":
                  if (data.from[property]) {
                    htmlArray.push(data.from[property] + "%");
                  } else if (data.from[property] === 0) {
                    htmlArray.push("0%");
                  } else {
                    htmlArray.push("-");
                  }
                  break;
                default:
                  if (data.from[property]) {
                    htmlArray.push(data.from[property]);
                  } else {
                    htmlArray.push("-");
                  }
                  break;
              }
              return htmlArray;
            })()}
          </ColumnValues>
        </ColumnValueFirst>
        <ColumnValueFirst paddingBottom="20px">
          <ColumnValues></ColumnValues>
        </ColumnValueFirst>
        <ColumnValueFirst paddingBottom="20px">
          <ColumnValues></ColumnValues>
        </ColumnValueFirst>
        <ColumnValueFirst paddingBottom="20px">
          <ColumnValues></ColumnValues>
        </ColumnValueFirst>
        <ColumnValueFirst paddingBottom="20px">
          <ColumnValues></ColumnValues>
        </ColumnValueFirst>
        <ColumnValueFirst paddingBottom="20px">
          <ColumnValues></ColumnValues>
        </ColumnValueFirst>
        <ColumnValues>
          {(() => {
            let htmlArray = [];
            switch (property) {
              case "amount":
              case "nav":
                if (data.to[property]) {
                  htmlArray.push(
                    formatter({
                      value: data.to[property],
                      fieldSuffix: "Dollars"
                    })
                  );
                } else if (data.to[property] === 0) {
                  htmlArray.push("$0.00");
                } else {
                  htmlArray.push("-");
                }
                break;
              case "date":
                if (data.to[property]) {
                  htmlArray.push(milliToDate(data.to[property]));
                } else {
                  htmlArray.push("-");
                }
                break;
              case "percentage":
                if (data.to[property]) {
                  htmlArray.push(data.to[property] + "%");
                } else if (data.to[property] === 0) {
                  htmlArray.push("0%");
                } else {
                  htmlArray.push("-");
                }
                break;
              default:
                if (data.to[property]) {
                  htmlArray.push(data.to[property]);
                } else {
                  htmlArray.push("-");
                }
                break;
            }
            return htmlArray;
          })()}
        </ColumnValues>
      </div>
    );
  }
};
const renderNav = data => {
  return (
    <ColumnWrapDiv>
      <ColumnValueFirst paddingBottom="35px">
        <ColumnValuesBegEnd>
          {data.fromNav
            ? formatter({
                value: data.fromNav,
                fieldSuffix: "Dollars"
              })
            : data.fromNav === 0
            ? "$0.00"
            : "-"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="20px">
        <ColumnValues>Grant</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="22px">
        <ColumnValues>Contribution</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="33px">
        <ColumnValues>exchange</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="30px">
        <ColumnValues>Other</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="40px">
        <ColumnValues>MM</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="10px">
        <ColumnValuesBegEnd>
          {data.nav
            ? formatter({
                value: data.nav,
                fieldSuffix: "Dollars"
              })
            : data.nav === 0
            ? "$0.00"
            : "-"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
    </ColumnWrapDiv>
  );
};
const renderAmount = data => {
  return (
  <ColumnWrapDiv>
      <ColumnValueFirst paddingBottom="35px">
        <ColumnValuesBegEnd>
          {data.fromAmount
            ? AmountFormatter(data.fromAmount): "$0.00"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>
          {data.contributionAmount && data.contributionAmount > 0
            ? AmountFormatter(data.contributionAmount)
            : data.contributionAmount < 0
            ? "(" + AmountFormatter(data.contributionAmount)+ ")"
            : "$0.00"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="22px">
        <ColumnValues>
          {data.grantAmount && data.grantAmount > 0
            ? AmountFormatter(data.grantAmount)
            : data.grantAmount < 0
            ? "(" + AmountFormatter(data.grantAmount) + ")"
            : "$0.00"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="33px">
        <ColumnValues>
          {data.exchangeAmount && data.exchangeAmount > 0
            ? AmountFormatter(data.exchangeAmount)
            : data.exchangeAmount < 0
            ? "(" + AmountFormatter(data.exchangeAmount) + ")"
            : "$0.00"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="30px">
        <ColumnValues>
          {data.otherAmount && data.otherAmount > 0
            ? AmountFormatter(data.otherAmount)
            : data.otherAmount < 0
            ? "(" + AmountFormatter(data.otherAmount) + ")"
            : "$0.00"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="40px" >
        <ColumnValues>
          {data.marketMovement && data.marketMovement > 0
            ? AmountFormatter(data.marketMovement)
            : data.marketMovement < 0
            ? "(" + AmountFormatter(data.marketMovement) + ")"
            : "$0.00"}{" "}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="10px">
        <ColumnValuesBegEnd>
          {data.amount
            ? AmountFormatter(data.amount)
            : "$0.00"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
    </ColumnWrapDiv>
  );
};
const UnitsFormatter = data =>{
  let val;
  { data <0 ?
  ( val = formatter({
    value: Math.abs(data),
    fieldSuffix: "Units"
  }) ):
  ( val = formatter({
    value: data,
    fieldSuffix: "Units"
  }))
  return val
}
}
const AmountFormatter = data =>{
  let val;
  { data <0 ?
  ( val = formatter({
    value: Math.abs(data),
    fieldSuffix: "Dollars"
  }) ):
  ( val = formatter({
    value: data,
    fieldSuffix: "Dollars"
  }))
  return val
}
}
const renderPercentage = data => {
  return (
    <ColumnWrapDiv>
      <ColumnValueFirst paddingBottom="35px">
        <ColumnValuesBegEnd>
          {data.fromPercentage
            ? formatter({
              value: data.fromPercentage,
              fieldSuffix: "PercentWDecimal"
            })
            : "0.00%"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="20px">
        <ColumnValues>grants</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="22px">
        <ColumnValues>contribution</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="33px">
        <ColumnValues>exchange</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="30px">
        <ColumnValues>other</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="40px">
        <ColumnValues>mm</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="10px">
        <ColumnValuesBegEnd>
          {data.percentage
            ? formatter({
              value: data.percentage,
              fieldSuffix: "PercentWDecimal"
            })
            : "0.00%"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
    </ColumnWrapDiv>
  );
};
const renderUnits = data => {
  return (
    <ColumnWrapDiv>
      <ColumnValueFirst paddingBottom="35px">
        <ColumnValuesBegEnd>
          {data.fromUnits && data.fromUnits > 0
            ? UnitsFormatter(data.fromUnits)
            : data.fromUnits < 0
            ? "(" + UnitsFormatter(data.fromUnits) + ")"
            : "-"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>
          {data.contributionUnits && data.contributionUnits > 0
            ? UnitsFormatter(data.contributionUnits)
            : data.contributionUnits < 0
            ? "(" + UnitsFormatter(data.contributionUnits) + ")"
            : "-"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="22px">
        <ColumnValues>
          {data.grantsUnits && data.grantsUnits > 0
            ? UnitsFormatter(data.grantsUnits)
            : data.grantsUnits < 0
            ? "(" + UnitsFormatter(data.grantsUnits) + ")"
            : "-"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="33px">
        <ColumnValues>
          {data.exchangeUnits && data.exchangeUnits > 0
            ? UnitsFormatter(data.exchangeUnits)
            : data.exchangeUnits < 0
            ? "(" + UnitsFormatter(data.exchangeUnits) + ")"
            : "-"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="30px">
        <ColumnValues>
          {data.otherUnits && data.otherUnits > 0
            ? UnitsFormatter(data.otherUnits)
            : data.otherUnits < 0
            ? "(" + UnitsFormatter(data.otherUnits) + ")"
            : "-"}
        </ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst style={{ visibility: "hidden" }} paddingBottom="40px">
        <ColumnValues>MM</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="10px">
        <ColumnValuesBegEnd>
          {data.units && data.units > 0
            ? UnitsFormatter(data.units)
            : data.units < 0
            ? "(" + UnitsFormatter(data.units) + ")"
            : "-"}
        </ColumnValuesBegEnd>
      </ColumnValueFirst>
    </ColumnWrapDiv>
  );
};

const renderDescription = () => {
  return (
    <div>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValuesBegEnd>Beginning Balance</ColumnValuesBegEnd>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>Contributions</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>Grants</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>Exchanges</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>Other Transactions</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst paddingBottom="20px">
        <ColumnValues>Market Movement</ColumnValues>
      </ColumnValueFirst>
      <ColumnValueFirst>
        <ColumnValuesBegEnd>Ending Balance</ColumnValuesBegEnd>
      </ColumnValueFirst>
    </div>
  );
};

export const BalanceDetailsTablePrint = props => {
  let balanceData = [];
  if (props.filterData) {
    for (var key in props.filterData) {
      if (props.filterData.hasOwnProperty(key)) {
        balanceData.push({
          option: key,
          from: props.filterData[key].from,
          to: props.filterData[key].to,
          contribution: props.filterData[key].contribution,
          exchange: props.filterData[key].exchange,
          grant: props.filterData[key].grant,
          other: props.filterData[key].other,
          marketMovement: props.filterData[key].marketMovement
        });
      }
    }
  }

  let columnsPrint = [
    {
      title: "Pool Name",
      dataIndex: "poolname",
      key: "poolname"
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description"
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount"
    },
    {
      title: "Units",
      dataIndex: "units",
      key: "units"
    }, 
    {
      title: "NAV",
      dataIndex: "nav",
      key: "nav"
    }, 
    {
      title: "Percentage",
      dataIndex: "percentage",
      key: "percentage"
    }
  ];

  let mainData = [];
  let mainDataPrint = [];
  if (balanceData) {
    balanceData.map(data => {
      mainData.push({
        option: data.option,
        fromAmount: data.from.amount,
        amount: data.to.amount,
        date: renderData(data, "date"),
        fromDate: data.from.date,
        units: data.to.units,
        fromUnits: data.from.units,
        nav: data.to.nav,
        fromNav: data.from.nav,
        percentage: data.to.percentage,
        fromPercentage: data.from.percentage,
        marketMovement: data.marketMovement,
        contributionAmount: data.contribution.amount,
        grantAmount: data.grant.amount,
        exchangeAmount: data.exchange.amount,
        otherAmount: data.other.amount,
        contributionUnits: data.contribution.units,
        grantsUnits: data.grant.units,
        exchangeUnits: data.exchange.units,
        otherUnits: data.other.units
      });
      return true;
    });
  }

  if (mainData) {
    mainData.map(data => {
      mainDataPrint.push({
        poolname: data.option,
        description: renderDescription(),
        amount: renderAmount(data),
        units: renderUnits(data),
        nav:renderNav(data),
        percentage:renderPercentage(data)
      });
      return true;
    });
  }

  return (
      <PrintTable
            dataSource={mainDataPrint}
            columns={columnsPrint}
            clsName='print_transaction_sum'
          /> 
  );
};

BalanceDetailsTablePrint.propTypes = {
  filterData: PropTypes.object,
  balanceDetails: PropTypes.object
};

const mapStateToProps = state => ({
  filterData: state.getIn([
    "transactionSummary",
    "filterData",
    "data",
    "sortedBalanceDetails"
  ]),
  balanceDetails: state.getIn(["transactionSummary", "balanceDetails", "data"])
});

export default connect(mapStateToProps)(BalanceDetailsTablePrint);
